import { ChangeEvent } from 'react'
import { useIntl } from 'react-intl'
import TextareaAutosize from 'react-textarea-autosize'

import { Textarea } from 'Components/_theme'

import { CUSTOMER_LABEL_CHARACTER_LIMIT } from './OrderSummary.constants'
import { OrderSummaryCustomerLabelInputProps } from './OrderSummary.types'

export const OrderSummaryCustomerLabelInput = (
  props: OrderSummaryCustomerLabelInputProps,
) => {
  const { controlId, defaultValue, onChangeLabel } = props
  const intl = useIntl()
  const placeholder = intl.formatMessage(
    {
      id: 'NewOrderSummary_label_placeholder',
    },
    {
      limit: CUSTOMER_LABEL_CHARACTER_LIMIT,
    },
  )

  const handleOnChangeLabel = (event: ChangeEvent<HTMLTextAreaElement>) => {
    if (event.target.value.length >= CUSTOMER_LABEL_CHARACTER_LIMIT) {
      return
    }

    onChangeLabel(event)
  }

  return (
    <Textarea
      charactersCount={defaultValue.length}
      className="pt-2"
      customComponent={TextareaAutosize}
      defaultValue={defaultValue}
      id={controlId}
      maxLength={CUSTOMER_LABEL_CHARACTER_LIMIT}
      onChange={handleOnChangeLabel}
      placeholder={placeholder}
      showCounter
      size="small"
    />
  )
}
